import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './StyledTable.module.scss'

interface IProps {
  title?: string
}

export const TableTitle = ({ title }: IProps) => {
  if (!title) {
    return null
  }
  return (
    <div className={styles.tableTitle}>
      <Translation text={title} />
    </div>
  )
}
